import withDesign from './hoc/withDesign';
import ValidatorAdapter from './validator';
import renderViews from './Components/RenderViews';
import availableFormControllersHashMap from './Components/Controllers';
import FormManager, { FormContainer, InputAdapter } from '@libs/react-easy-form';

// ================================
// EXTENDING THE FORM LIBRARY
// ================================

// Registering a validator
FormContainer.registerValidator(new ValidatorAdapter());

// Registering our custom Controllers views
for (const [key, RenderView] of Object.entries(renderViews)) {
  FormContainer.registerViewRenders(key, RenderView);
}

// Registering our controllers | The library is agnostic to the components
for (const [key, Controller] of Object.entries(availableFormControllersHashMap)) {
  FormContainer.registerController(key, InputAdapter(withDesign(Controller)));
}

// Export our customized instance of the Library
export default FormManager;
